module.exports = __webpack_public_path__ + "static/media/entrance.c90960f2.png";